import axios from 'axios';

import identity from 'lodash/identity';
import pick from 'lodash/pick';

import { isServer } from '@utils/browser';
import config from '@config';

const log = (title, attrs, isError) => data => {
  if (isServer) {
    console.log(
      `${title} ------------------------------------------------------`
    );
    console.log(attrs ? pick(data, attrs) : data);
    console.log(
      '---------------------------------------------------------------'
    );
  }

  if (isError) throw data;
  return data;
};

const logRequest = log('API Request');
const logResponse = log('API Response', ['status', 'statusText', 'data']);
const logError = log(
  'API Error',
  ['response.status', 'response.statusText', 'response.data'],
  true
);

export default ['get', 'post', 'put', 'patch', 'delete'].reduce(
  (req, method) => ({
    ...req,
    [method]: (...args) => {
      if (config.logger) {
        logRequest({ ...args, method });
      }

      return axios[method]
        .apply(axios, args)
        .then(config.logger ? logResponse : identity)
        .catch(logError);
    }
  }),
  {}
);
